import React, { useRef, useEffect, useState } from "react";
import Const from "../components/Const";
import { Table } from "reactstrap";
import ReactTooltip from "react-tooltip";

import {
  MonthToCanChi,
  nguHanh,
  ThapThan,
  ThanSatDiaChi,
  ThanSatThienCan,
  TangCan,
  YearToCan,
} from "../components/convert";
import TableDay from "./TableDay";
import { handleCheckDungThan } from "./dungThanUtils";

const TableThangDaiVan = ({ year, thienCanNgay, dungThan, checkDungThan }) => {
  const [thangData, setThangData] = useState([]);
  const [tangCanThang, setTangCanThang] = useState([]);

  const [objectDaiVanData, setObjectDaiVan] = useState([]);
  const [dataMonthYear, setMonthYear] = useState({
    year: year,
    month: "",
  });

  const [showDay, setshowDay] = useState(false);

  // Lấy cài đặt dụng thần từ localStorage
  const profile = JSON.parse(localStorage.getItem("profile")) || {};
  const dungThanCaiDatThienCan = profile.dungThanCaiDatThienCan || [];
  const dungThanCaiDatDiaChi = profile.dungThanCaiDatDiaChi || [];

  const handelThienCan = (thienCan) => {
    let thuTuThienCan = Const.thuTuThienCan.findIndex((x) => x === thienCan);
    thuTuThienCan -= 2;
    if (thuTuThienCan === -1) {
      thuTuThienCan = 9;
    }

    return Const.thuTuThienCan[thuTuThienCan];
  };

  const handleResult = async () => {
    let month = 0;
    let monthShow = 1;
    const result = [];
    const tangCanThang = [];
    let objectDaivan = [];
    let currentYear = new Date().getFullYear();
    for (let index = 0; index < 12; index++) {
      const date = new Date(year, month);

      const dateTietKhi = date;

      const canYear = YearToCan(dateTietKhi.getFullYear()); //

      const canChiMonth = MonthToCanChi(canYear?.name, dateTietKhi?.getMonth());
      let thienCanMonth = canChiMonth?.name?.split(" ")[0];
      if (index === 0) thienCanMonth = handelThienCan(thienCanMonth);
      const diaChiMonth = canChiMonth?.name?.split(" ")[1];
      const nguHanhTC = nguHanh(thienCanNgay, thienCanMonth);
      const thapThan = ThapThan(thienCanNgay, thienCanMonth);

      const thanSatMonthArr = ThanSatDiaChi(thienCanNgay, thienCanMonth);
      const thanSatMonthCan = ThanSatThienCan(thienCanNgay, thienCanMonth);
      const TangCanMonthArr = TangCan(diaChiMonth);
      const thapThanMonth1 = ThapThan(thienCanNgay, TangCanMonthArr[0]?.name);
      const thapThanMonth2 = ThapThan(thienCanNgay, TangCanMonthArr[1]?.name);
      const thapThanMonth3 = ThapThan(thienCanNgay, TangCanMonthArr[2]?.name);

      tangCanThang.push({
        TangCan: TangCanMonthArr,
        ThapThan1: thapThanMonth1,
        ThapThan2: thapThanMonth2,
        ThapThan3: thapThanMonth3,
        year,
        month: monthShow,
      });
      result.push({
        thienCan: thienCanMonth,
        diaChi: diaChiMonth,
        nguHanhTC,
        thapThan,
        thanSatMonthArr,
        thanSatMonthCan,
        month: monthShow,
        year,
      });
      month += 1;
      monthShow += 1;
    }
    // result[0].thienCan = handelThienCan(result[0].thienCan);

    // result[0].thienCan = handelThienCan(result[0].thienCan);

    if (result[0]?.year <= currentYear && result[0]?.year > currentYear - 10) {
      objectDaivan = result[0];
    }
    tangCanThang.reverse();
    result.reverse();
    setThangData(result);
    setObjectDaiVan(objectDaivan);
    setTangCanThang(tangCanThang);
  };

  useEffect(() => {
    setMonthYear({
      ...dataMonthYear,
      year: year,
    });
    handleResult();
  }, [year]);

  return (
    <>
      <div
        id="table_dv"
        style={{
          maxWidth: "1600px",
          margin: "0 auto",
          zIndex: "1000",
          position: "relative",
          overflowX: "scroll",
        }}
      >
        <Table
          hover
          bordered
          style={{
            textAlign: "center",
            marginTop: "35px",
          }}
        >
          <tbody>
            <tr className="fz__16">
              {thangData?.map((x) => {
                return (
                  <td
                    onClick={() => {
                      setshowDay(true);
                      setMonthYear({
                        ...dataMonthYear,
                        month: x.month,
                      });
                    }}
                    id={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang1"
                        : ""
                    }
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    className={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "border__1px background_"
                        : "border__1px"
                    }
                  >
                    ({x.year}) <br /> Tháng {x.month}
                  </td>
                );
              })}

              <th
                id="bg__age"
                className="bg__ clr__white fz__15 fw__b"
                style={{ width: "58px" }}
              >
                Tháng
              </th>
            </tr>

            <tr style={{ textAlign: "center" }}>
              {thangData.map((x) => {
                // Logic tô màu Thiên Can (dòng trên - hiển thị chữ Thiên Can)
                const isDungThanThienCanRow = handleCheckDungThan(x.thienCan, dungThan, dungThanCaiDatThienCan, checkDungThan);

                return (
                  <td
                    onClick={() => {
                      setMonthYear({
                        ...dataMonthYear,
                        month: x.month,
                      });
                      setshowDay(true);
                    }}
                    id={
                      isDungThanThienCanRow
                        ? "dungThan"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang2"
                        : ""
                    }
                    style={{ fontWeight: "bold", cursor: "pointer" }}
                    className={
                      isDungThanThienCanRow
                        ? "fz__22 clr__ border__1px background"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "fz__22 clr__ border__1px background_"
                        : "fz__22 clr__ border__1px"
                    }
                  >
                    <div data-for="con-giap" data-tip={x.thienCan}>
                      <sup className="fz__15" style={{ paddingRight: "4px" }}>
                        {x.thapThan?.sinhKhac}
                      </sup>
                      {x.thienCan}
                    </div>
                  </td>
                );
              })}

              <th
                id="bg__lnntc"
                rowSpan="2"
                className="bg__ clr__white fz__15 fw__b"
                data-for="thien-can"
                data-tip="Thiên Can"
              >
                Thiên Can
              </th>
            </tr>

            <tr style={{ textAlign: "center" }}>
              {thangData.map((x) => {
                // Dòng dưới của Thiên Can (hiển thị ngũ hành) - không tô màu
                return (
                  <th
                    onClick={() => {
                      setMonthYear({
                        ...dataMonthYear,
                        month: x.month,
                      });
                      setshowDay(true);
                    }}
                    style={{ fontWeight: "normal", cursor: "pointer" }}
                    colspan="1"
                    className={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "fz__15 border__1px background_"
                        : "fz__15 border__1px"
                    }
                    id={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang3"
                        : ""
                    }
                  >
                    {x.nguHanhTC}
                  </th>
                );
              })}
            </tr>

            <tr>
              {thangData.map((x) => {
                // Logic tô màu Địa Chi
                const isDungThanDiaChi = handleCheckDungThan(x.diaChi, dungThan, dungThanCaiDatDiaChi, checkDungThan);

                return (
                  <td
                    onClick={() =>
                      setMonthYear({
                        ...dataMonthYear,
                        month: x.month,
                      })
                    }
                    id={
                      isDungThanDiaChi
                        ? "dungThan"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang4"
                        : ""
                    }
                    style={{ fontWeight: "bold", cursor: "pointer" }}
                    className={
                      isDungThanDiaChi
                        ? "fz__22 clr__ border__1px background"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "fz__22 clr__ border__1px background_"
                        : "fz__22 clr__ border__1px"
                    }
                  >
                    {x.diaChi}
                  </td>
                );
              })}

              <th
                id="bg__lnndc"
                rowSpan="1"
                className="bg__ clr__white fz__15 fw__b"
                data-for="dia-chi"
                data-tip="Địa Chi"
              >
                Địa Chi
              </th>
            </tr>

            <tr className="fz__10">
              {tangCanThang?.map((val) => {
                // Tàng Can - không tô màu dụng thần
                return (
                  <td
                    onClick={() => {
                      setMonthYear({
                        ...dataMonthYear,
                        month: val.month,
                      });
                      setshowDay(true);
                    }}
                    style={{
                      verticalAlign: "middle",
                      padding: "0",
                      cursor: "pointer",
                    }}
                    className={
                      objectDaiVanData.year === val.year && val.month === 1
                        ? "border__1px background_"
                        : "border__1px"
                    }
                    id={
                      objectDaiVanData.year === val.year && val.month === 1
                        ? "bg_hang5"
                        : ""
                    }
                  >
                    {val.TangCan[1]?.name ? (
                      <td
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none_bg"
                            : "none"
                        }
                        style={{
                          border: "none",
                          padding: "0 10px 0 10px",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan2?.sinhKhac}</sup>

                          {val?.TangCan[1]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[1]?.nguHanh}</div>
                        </div>
                      </td>
                    ) : (
                      ""
                    )}

                    {val?.TangCan[1]?.name && val?.TangCan[2]?.nguHanh ? (
                      <th
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none3_bg"
                            : "none3"
                        }
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          borderTop: "none",
                          borderBottom: "none",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan1.sinhKhac}</sup>
                          {val?.TangCan[0]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[0]?.nguHanh}</div>
                        </div>
                      </th>
                    ) : val?.TangCan[2]?.name ? (
                      <th
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none_bg4"
                            : "none4"
                        }
                        style={{
                          borderLeft: "none",
                          borderRight: "1px solid black",
                          borderTop: "none",
                          borderBottom: "none",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan1.sinhKhac}</sup>
                          {val?.TangCan[0]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[0]?.nguHanh}</div>
                        </div>
                      </th>
                    ) : (
                      <th
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none2_bg"
                            : "none2"
                        }
                        style={{
                          border: "none",
                          display: "inline-block",
                          margin: 0,
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan1.sinhKhac}</sup>
                          {val?.TangCan[0]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[0]?.nguHanh}</div>
                        </div>
                      </th>
                    )}

                    {val?.TangCan[2]?.name && val?.TangCan[1]?.name ? (
                      <td
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none2_bg"
                            : "none2"
                        }
                        style={{
                          border: "none",
                          padding: "0 5px",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan3?.sinhKhac}</sup>

                          {val?.TangCan[2]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[2]?.nguHanh}</div>
                        </div>
                      </td>
                    ) : (
                      <td
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none2_bg"
                            : "none2"
                        }
                        style={{
                          border: "none",
                          padding: "0 15px",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan3?.sinhKhac}</sup>

                          {val?.TangCan[2]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[2]?.nguHanh}</div>
                        </div>
                      </td>
                    )}
                  </td>
                );
              })}

              <th id="bg__lnntcc" className="bg__ clr__white fz__15 fw__b">
                Tàng Can
              </th>
            </tr>
          </tbody>
        </Table>
      </div>

      {showDay && checkDungThan && (
        <TableDay
          month={dataMonthYear.month}
          year={dataMonthYear.year}
          dungThan={dungThan}
          checkDungThan={checkDungThan}
          thienCanDay={thienCanNgay}
        />
      )}
      <ReactTooltip
        id="con-giap"
        getContent={(dataTip) => (
          <div>
            <h5 style={{ textAlign: "center" }}>{dataTip}</h5>
            <p style={{ color: "blue" }}>
              Xin vui lòng{" "}
              <span
                className="click-span"
                onClick={() => {
                  if (dataTip === "Giáp") {
                    window.open(
                      "https://www.youtube.com/watch?v=N9E8dt6mtHc&t=31s"
                    );
                  } else if (dataTip === "Ất") {
                    window.open("https://www.youtube.com/watch?v=phqBCvqlLVk");
                  } else if (dataTip === "Bính") {
                    window.open("https://www.youtube.com/watch?v=MWg_sgJxcto");
                  } else if (dataTip === "Đinh") {
                    window.open("https://www.youtube.com/watch?v=-QB6i5bWwxE");
                  } else if (dataTip === "Mậu") {
                    window.open("https://www.youtube.com/watch?v=qs5jw6rGNBI");
                  } else if (dataTip === "Kỷ") {
                    window.open("https://www.youtube.com/watch?v=7Q3ivslkQk4");
                  } else if (dataTip === "Canh") {
                    window.open("https://www.youtube.com/watch?v=cNZGmL6mpAI");
                  } else if (dataTip === "Tân") {
                    window.open("https://www.youtube.com/watch?v=xR1EIu_J6oo");
                  } else if (dataTip === "Nhâm") {
                    window.open("https://www.youtube.com/watch?v=SUdNG6Zuoow");
                  } else if (dataTip === "Quý") {
                    window.open(
                      "https://www.youtube.com/watch?v=thOn-UpGob8&t=8s"
                    );
                  }
                }}
              >
                Click
              </span>{" "}
              vào đây để tìm hiểu thêm
            </p>
          </div>
        )}
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        place="top"
        border={true}
        type="light"
      />
      <ReactTooltip
        id="thien-can"
        getContent={(dataTip) => (
          <div>
            <h5 style={{ textAlign: "center" }}>{dataTip}</h5>
            <p style={{ color: "blue" }}>
              Xin vui lòng
              <span
                className="click-span"
                onClick={() => {
                  window.open(
                    "https://www.phongthuytuongminh.com/thien-can-dia-chi-la-gi-thien-can-dia-chi-co-y-nghia-quan-trong-nhu-the-nao.html"
                  );
                }}
              >
                {" "}
                Click{" "}
              </span>
              vào đây để tìm hiểu thêm
            </p>
          </div>
        )}
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        place="top"
        border={true}
        type="light"
      />
      <ReactTooltip
        id="dia-chi"
        getContent={(dataTip) => (
          <div>
            <h5 style={{ textAlign: "center" }}>{dataTip}</h5>
            <p style={{ color: "blue" }}>
              Xin vui lòng
              <span
                className="click-span"
                onClick={() => {
                  window.open(
                    "https://www.phongthuytuongminh.com/vi/thien-can-dia-chi-la-gi-thien-can-dia-chi-co-y-nghia-quan-trong-nhu-the-nao.html"
                  );
                }}
              >
                {" "}
                Click{" "}
              </span>
              vào đây để tìm hiểu thêm
            </p>
          </div>
        )}
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        place="top"
        border={true}
        type="light"
      />
    </>
  );
};

export default TableThangDaiVan;
